import { render, staticRenderFns } from "./GroupSearchListComp.vue?vue&type=template&id=08a3519c&scoped=true"
import script from "./GroupSearchListComp.vue?vue&type=script&lang=js"
export * from "./GroupSearchListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a3519c",
  null
  
)

export default component.exports